import { Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  standalone: false,
})
export class ProgressSpinnerComponent {
  readonly customer = input<boolean>(false);
}
